import { Component, OnInit } from '@angular/core';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-stock-history',
  templateUrl: './stock-history.component.html',
  styleUrls: ['./stock-history.component.css']
})
export class StockHistoryComponent implements OnInit {
    stockKeyno;

    public setting?: Setting;

    public itemsListHistories: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadSetting() {
        if (!!this.stockKeyno) {
            this.setting = (await this.datatask.Post(1420, { stock_keyno: this.stockKeyno }))[0];
        }
    }

    private async loadHistories() {
        if (!!this.setting) {
            this.itemsListHistories = await this.datatask.Post(1419, this.setting);
        }
    }

    public updateHistories() {
        return this.loadHistories();
    }

    private async init() {
        await this.loadSetting();
        this.loadHistories();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    filtervalue: string;
    show_setting: string;
    stock_keyno: number;
}
